/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */
import { put, race, select, take } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import * as AuthN from './authN';

function* getAuthN(): SagaIterator<string> {
  const processedWithError = yield select(AuthN.Selectors.error);

  // if the previous request state was error then request again
  if (processedWithError) {
    yield put(AuthN.ActionCreators.request());
  }

  // check if there is any pending request and wait to be completed
  const isGettingNewToken = yield select(AuthN.Selectors.isProcessing);

  if (isGettingNewToken) {
    const { fail } = yield race({
      success: take(AuthN.ActionType.SUCCESS),
      fail: take(AuthN.ActionType.FAIL),
    });

    if (fail) {
      throw fail.error;
    }
  }

  return yield select(AuthN.Selectors.selectToken);
}

export default {
  getAuthN,
};
